/*
 * @Author: zhouwei
 * @Date: 2019-10-08 10:34:32
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-06-05 17:29:28
 * @Desc: 定时计划页面
*/
<template>
  <div class="time-plan">
    <div class="search">
      <mk-input
        v-model="planName"
        class="name"
        placeholder="请输入计划名称"
        clearable
        width="240"
        @clear="search"
        @keyup.enter.native="search"
      >
        <div
          slot="suffix"
          class="el-input__icon"
        >
          <i
            class="el-icon-search"
            @click="search"
          />
        </div>
      </mk-input>
      <mk-select
        v-model="optionsData.planningStatus.value"
        class="select"
        :placeholder="optionsData.planningStatus.defaultText"
        width="128"
        clearable
        @change="change"
      >
        <mk-option
          v-for="item in optionsData.planningStatus.list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </mk-option>
      </mk-select>
      <mk-button-biz
        type="primary"
        icon="el-icon-search"
        @click="search"
      >
        搜索
      </mk-button-biz>
      <mk-button-biz @click="reset">
        重置
      </mk-button-biz>

      <mk-button-biz
        type="primary"
        icon="el-icon-plus"
        width="136px"
        class="add-plan"
        @click="addPlan"
      >
        创建定时计划
      </mk-button-biz>
    </div>
    <div class="list">
      <mk-table
        v-if="tableMaxHeight"
        :max-height="tableMaxHeight"
        :data="tableData"
        style="width: 100%;"
      >
        <mk-table-column
          prop="name"
          label="计划名称"
          min-width="240"
        >
        </mk-table-column>
        <mk-table-column
          prop="executor"
          label="执行成员"
          width="160"
          show-overflow-tooltip
        >
          <template v-slot="scope">
            <span class="executor-detail">
              {{ handleExecutor(scope.row.executor) }}
            </span>
          </template>
        </mk-table-column>
        <mk-table-column
          prop="time"
          label="计划时间"
          width="270"
        >
        </mk-table-column>
        <mk-table-column
          prop="remarks"
          label="备注"
          min-width="150"
          show-overflow-tooltip
        >
        </mk-table-column>
        <mk-table-column
          prop="state"
          label="计划状态"
          width="100"
        >
          <template v-slot="scope">
            <span v-if="scope.row.state === 0">未发布</span>
            <span v-if="scope.row.state === 1">未开始</span>
            <span
              v-if="scope.row.state === 2"
              style="color:rgb(56, 183, 56);"
            >进行中</span>
            <span v-if="scope.row.state === 3">已结束</span>
          </template>
        </mk-table-column>
        <mk-table-column
          prop="handle"
          label="操作"
          width="100"
          fixed="right"
        >
          <template v-slot="scope">
            <div v-if="scope.row.state === 0">
              <mk-button-biz
                type="text"
                class="operate"
                @click="handleClick(scope,'publish',scope.row.id,scope.row.startTime,scope.row.state)"
              >
                发布
              </mk-button-biz>
              <mk-button-biz
                type="text"
                class="operate"
                @click="handleClick(scope,'detail',scope.row.id,scope.row.startTime,scope.row.state)"
              >
                详情
              </mk-button-biz>
            </div>
            <div v-if="scope.row.state === 1">
              <mk-button-biz
                type="text"
                class="operate"
                @click="handleClick(scope,'detail',scope.row.id,scope.row.startTime,scope.row.state)"
              >
                详情
              </mk-button-biz>
            </div>
            <div v-if="scope.row.state === 2 || scope.row.state === 3">
              <mk-button-biz
                type="text"
                class="operate"
                @click="handleClick(scope,'detail',scope.row.id,scope.row.startTime,scope.row.state)"
              >
                详情
              </mk-button-biz>
              <mk-button-biz
                type="text"
                class="operate"
                @click="handleClick(scope,'data',scope.row.id,scope.row.startTime,scope.row.state)"
              >
                数据
              </mk-button-biz>
            </div>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div class="pagination">
      <mk-pagination
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </mk-pagination>
    </div>
  </div>
</template>
<script>
import { BIZAPIS } from '@api'
export default {
  name: 'PlanIndex',
  data () {
    return {
      tableMaxHeight: 0,
      show: true,
      showDetail: false,
      planName: '',
      total: 0,
      page: 1,
      optionsData: {
        targetCustomers: {
          value: '',
          defaultText: '目标客户',
          list: [
            // 未选择代表全部
            {
              value: 0,
              label: '任意好友'
            },
            {
              value: 1,
              label: '指定微信好友'
            }
          ]
        },
        planningStatus: {
          value: '',
          defaultText: '计划状态',
          list: [
            // {
            //   value: 0,
            //   label: '未发布'
            // },
            {
              value: 1,
              label: '未开始'
            },
            {
              value: 2,
              label: '进行中'
            },
            {
              value: 3,
              label: '已结束'
            }
          ]
        }
      },
      tableData: [
        /**
         * state代表不同状态的值
         * 0: 未发布
         * 1: 未开始
         * 2: 进行中
         * 3: 已结束
         */
      ]
    }
  },
  created () {
    this.getListData()
  },
  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.list', this)
    })
  },
  methods: {
    change (e) {
      this.optionsData.planningStatus.value = e
      this.getListData()
    },
    search () {
      this.getListData()
    },
    async getListData () {
      let metas = {
        page: this.page
      }
      if (this.planName !== '' && this.planName !== undefined) {
        metas.name = this.planName
      }
      if (
        this.optionsData.planningStatus.value !== '' &&
        this.optionsData.planningStatus.value !== undefined
      ) {
        metas.status = Number(this.optionsData.planningStatus.value)
      }
      const res = await BIZAPIS.MarketingPlanApi.timingPlanIndexPost(metas)
      if (res.success) {
        this.total = res.data.total
        this.tableData = res.data.data
        if (res.data.data && res.data.data.length > 0) {
          let data = res.data.data
          let i = 0
          let len = data.length
          for (i; i < len; i++) {
            this.tableData[i] = {
              id: data[i]._id,
              name: data[i].name,
              executor: data[i].execDepartment,
              startTime: data[i].startTime,
              endTime: data[i].endTime,
              time: data[i].startTime + '~' + data[i].endTime,
              remarks: data[i].remarks,
              state: data[i].status
            }
          }
        }
      }
    },
    handleClick (e, type, id, startTime, status) {
      switch (type) {
        case 'detail':
          this.$router.push({
            path: '/marketing-content/marketing-plane/plan-detail',
            query: {
              id: id,
              status: status
            }
          })
          break
        case 'publish':
          this.publish(id)
          break
        case 'data':
          this.$router.push({
            path: '/marketing-content/marketing-plane/plan-detail',
            query: {
              id: id,
              status: status,
              showData: true
            }
          })
          break
        default:
          break
      }
      if (type === 'detail') {
        this.showDetail = true
      }
    },
    async publish (id) {
      // 发布
      this.$confirm('是否发布此营销计划?', '', {
        confirmButtonText: '发布',
        cancelButtonText: '取消',
        type: 'none'
      }).then(() => {
        this.publishPlan(id)
      })
    },
    async publishPlan (id) {
      // 发布计划
      const res = await BIZAPIS.MarketingPlanApi.timingPlanPatch({
        _id: id,
        status: 1
      })
      if (res.success) {
        this.getListData()
        this.$message({
          type: 'success',
          message: '发布成功!'
        })
      }
    },
    cancel () {
      this.show = false
    },
    cancelDetail () {
      this.showDetail = false
    },
    addPlan () {
      this.$router.push({
        path: '/marketing-content/marketing-plane/add-plan',
        query: {}
      })
    },
    reset () {
      this.optionsData.planningStatus.value = ''
      this.planName = ''
      this.getListData()
    },
    handleCurrentChange (e) {
      this.page = e
      this.getListData()
    },
    handleExecutor (item) {
      if (item.isAll) {
        return '全体成员'
      } else {
        if (item.children && item.children.length > 0) {
          let arr = item.children
          let strD = '' // 部门
          let strP = '' // 成员
          let str = '' // 最后返回结果
          arr.forEach((item, index) => {
            if (item.type === 1) {
              strD += item.name + '、'
            }
            if (item.type === 0) {
              strP += item.name + '、'
            }
          })
          strD = strD.substring(0, strD.length - 1)
          strP = strP.substring(0, strP.length - 1)
          if (strD === '') {
            str = strP
          } else if (strP === '') {
            str = strD
          } else {
            str = strD + '、' + strP
          }
          return str
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.time-plan {
  display: flex;
  flex-direction: column;
  width: calc(100% - 32px);
  height: 100%;
  margin: 0 auto;
  // padding-top: 24px;
  padding-top: 10px;
  box-sizing: border-box;

  .search {
    height: 32px;
    display: flex;
    align-items: center;

    & /deep/ .el-input__inner {
      padding-right: 50px;
    }

    & /deep/ .el-input__suffix {
      .el-input__clear {
        position: absolute;
        top: 0;
        left: -25px;
      }
    }

    .name {
      width: 168px;
      margin-right: 8px;
    }

    .select {
      margin-right: 8px;
    }

    .add-plan {
      margin-left: auto;
    }
  }

  .executor-detail {
    white-space: nowrap;
  }

  .list {
    flex: 1;
    // margin-top: 24px;
    margin-top: 10px;
    overflow: hidden;
  }

  .pagination {
    margin: 20px 0;
    display: flex;
    justify-content: flex-end;
  }

  .operate {
    font-weight: 400;
    color: #009cff;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}
</style>
